// @flow
import Immutable from "seamless-immutable";
import instConsts from "./consts";

const CTXS = instConsts.CONTEXTS;

export const getNewList = () => ({
	items: [],
	nextUrl: null,
	hasMore: false,
	inProgress: false,
	selected: [],
	lastSelectedIndex: -1,
});

export default () => Immutable({
	__record: "InstagramRecord",
	token: null,
	isAuth: false,
	listeningForAuth: false,
	lists: {
		[CTXS.RECENT]: getNewList(),
	},
	currentContext: CTXS.RECENT,
	currentAccount: {},
});
